import script from "./BikeInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BikeInfo.vue?vue&type=script&setup=true&lang=js"

import "./BikeInfo.vue?vue&type=style&index=0&id=2889257a&lang=css"

const __exports__ = script;

export default __exports__